<h2 mat-dialog-title>
  Aviso
</h2>
<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="fecharDialogo('Cancelar')">Cancelar</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="fecharDialogo('Confirmar')">Confirmar</button>
</mat-dialog-actions>